import { gql } from '@apollo/client';

import { subjectsTreeFragment } from '../fragments';

export default gql`
  mutation ReorderSubject($courseId: String!, $subjectId: String!, $input: ReorderSubjectInput!) {
    subjects(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "Subject", path: "courses/{args.courseId}/subjects/{args.subjectId}/reorder", method: "PUT") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
